var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7482 20.0987C21.8687 18.0343 20.3976 16.2761 18.4932 15.0146C17.0371 14.0496 15.3958 13.4247 13.6716 13.1695C16.3235 12.4169 18.2671 10.0295 18.2671 7.20848C18.2671 3.78507 15.4058 1 11.8891 1C8.3724 1 5.51117 3.78507 5.51117 7.20818C5.51117 10.0292 7.45441 12.4166 10.1066 13.1692C8.38279 13.4244 6.74117 14.0496 5.28504 15.0143C3.38091 16.2764 1.9095 18.0343 1.03002 20.0987C0.979594 20.2171 0.993346 20.3521 1.06638 20.4586C1.13942 20.5651 1.26257 20.629 1.39397 20.629H22.3837C22.5154 20.629 22.6382 20.5651 22.7113 20.4586C22.7843 20.3521 22.798 20.2171 22.7476 20.0987H22.7482ZM6.29929 7.20818C6.29929 4.20805 8.80695 1.76714 11.8891 1.76714C14.9713 1.76714 17.479 4.20805 17.479 7.20818C17.479 10.2083 14.9713 12.6492 11.8891 12.6492C8.80695 12.6492 6.29929 10.2083 6.29929 7.20818ZM2.00148 19.8622C3.82096 16.1642 7.6393 13.8057 11.8891 13.8057C16.139 13.8057 19.9573 16.1642 21.7768 19.8622H2.00148Z",
    fill: "#231F20",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.7cae3e424478849734c8e36bbbb5bd58.svg";
export { ForwardRef as ReactComponent };